import * as S from "./NavList.style";
import { NavItem } from "@/components/atoms/NavItem";

interface NavListProps {
  data: any;
}

export const NavList = ({ data }: NavListProps) => {
  return (
    <S.NavList>
      {data.map((item: any, index: number) => {
        return <NavItem data={item} key={index} />;
      })}
    </S.NavList>
  );
};
